var map = {
	"./aligners/alignersBottom_1.stl": 263592,
	"./aligners/alignersBottom_10.stl": 25019,
	"./aligners/alignersBottom_2.stl": 238156,
	"./aligners/alignersBottom_3.stl": 902036,
	"./aligners/alignersBottom_4.stl": 739157,
	"./aligners/alignersBottom_5.stl": 564454,
	"./aligners/alignersBottom_6.stl": 877557,
	"./aligners/alignersBottom_7.stl": 533509,
	"./aligners/alignersBottom_8.stl": 796697,
	"./aligners/alignersBottom_9.stl": 557426,
	"./aligners/alignersTop_1.stl": 274935,
	"./aligners/alignersTop_10.stl": 825128,
	"./aligners/alignersTop_2.stl": 648321,
	"./aligners/alignersTop_3.stl": 994113,
	"./aligners/alignersTop_4.stl": 21290,
	"./aligners/alignersTop_5.stl": 229249,
	"./aligners/alignersTop_6.stl": 746921,
	"./aligners/alignersTop_7.stl": 404643,
	"./aligners/alignersTop_8.stl": 977653,
	"./aligners/alignersTop_9.stl": 77111,
	"./ceramicBraces/ceramicBracesBottom_1.stl": 707323,
	"./ceramicBraces/ceramicBracesBottom_10.stl": 548105,
	"./ceramicBraces/ceramicBracesBottom_2.stl": 529810,
	"./ceramicBraces/ceramicBracesBottom_3.stl": 77528,
	"./ceramicBraces/ceramicBracesBottom_4.stl": 481309,
	"./ceramicBraces/ceramicBracesBottom_5.stl": 765185,
	"./ceramicBraces/ceramicBracesBottom_6.stl": 331756,
	"./ceramicBraces/ceramicBracesBottom_7.stl": 609595,
	"./ceramicBraces/ceramicBracesBottom_8.stl": 177267,
	"./ceramicBraces/ceramicBracesBottom_9.stl": 532842,
	"./ceramicBraces/ceramicBracesTop_1.stl": 965043,
	"./ceramicBraces/ceramicBracesTop_10.stl": 516316,
	"./ceramicBraces/ceramicBracesTop_2.stl": 524313,
	"./ceramicBraces/ceramicBracesTop_3.stl": 935107,
	"./ceramicBraces/ceramicBracesTop_4.stl": 923101,
	"./ceramicBraces/ceramicBracesTop_5.stl": 989892,
	"./ceramicBraces/ceramicBracesTop_6.stl": 248768,
	"./ceramicBraces/ceramicBracesTop_7.stl": 438532,
	"./ceramicBraces/ceramicBracesTop_8.stl": 70187,
	"./ceramicBraces/ceramicBracesTop_9.stl": 131548,
	"./ceramicRubber/ceramicRubberBottom_1.stl": 892458,
	"./ceramicRubber/ceramicRubberBottom_10.stl": 997811,
	"./ceramicRubber/ceramicRubberBottom_2.stl": 596599,
	"./ceramicRubber/ceramicRubberBottom_3.stl": 105872,
	"./ceramicRubber/ceramicRubberBottom_4.stl": 816570,
	"./ceramicRubber/ceramicRubberBottom_5.stl": 938615,
	"./ceramicRubber/ceramicRubberBottom_6.stl": 334167,
	"./ceramicRubber/ceramicRubberBottom_7.stl": 557431,
	"./ceramicRubber/ceramicRubberBottom_8.stl": 422959,
	"./ceramicRubber/ceramicRubberBottom_9.stl": 587550,
	"./ceramicRubber/ceramicRubberTop_1.stl": 288521,
	"./ceramicRubber/ceramicRubberTop_10.stl": 545455,
	"./ceramicRubber/ceramicRubberTop_2.stl": 976119,
	"./ceramicRubber/ceramicRubberTop_3.stl": 3339,
	"./ceramicRubber/ceramicRubberTop_4.stl": 497419,
	"./ceramicRubber/ceramicRubberTop_5.stl": 94599,
	"./ceramicRubber/ceramicRubberTop_6.stl": 604591,
	"./ceramicRubber/ceramicRubberTop_7.stl": 442406,
	"./ceramicRubber/ceramicRubberTop_8.stl": 777063,
	"./ceramicRubber/ceramicRubberTop_9.stl": 777172,
	"./frontArc/frontArcBottom_1.stl": 893177,
	"./frontArc/frontArcBottom_10.stl": 117407,
	"./frontArc/frontArcBottom_2.stl": 190413,
	"./frontArc/frontArcBottom_3.stl": 540260,
	"./frontArc/frontArcBottom_4.stl": 410169,
	"./frontArc/frontArcBottom_5.stl": 978852,
	"./frontArc/frontArcBottom_6.stl": 206681,
	"./frontArc/frontArcBottom_7.stl": 205859,
	"./frontArc/frontArcBottom_8.stl": 149831,
	"./frontArc/frontArcBottom_9.stl": 439900,
	"./frontArc/frontArcTop_1.stl": 667435,
	"./frontArc/frontArcTop_10.stl": 946079,
	"./frontArc/frontArcTop_2.stl": 723903,
	"./frontArc/frontArcTop_3.stl": 576034,
	"./frontArc/frontArcTop_4.stl": 247458,
	"./frontArc/frontArcTop_5.stl": 334330,
	"./frontArc/frontArcTop_6.stl": 86190,
	"./frontArc/frontArcTop_7.stl": 73159,
	"./frontArc/frontArcTop_8.stl": 241498,
	"./frontArc/frontArcTop_9.stl": 700411,
	"./gum/gumBottom.stl": 463544,
	"./gum/gumTop.stl": 12549,
	"./lingualArc/lingualArcBottom_1.stl": 959942,
	"./lingualArc/lingualArcBottom_10.stl": 580109,
	"./lingualArc/lingualArcBottom_2.stl": 381564,
	"./lingualArc/lingualArcBottom_3.stl": 16269,
	"./lingualArc/lingualArcBottom_4.stl": 838665,
	"./lingualArc/lingualArcBottom_5.stl": 19160,
	"./lingualArc/lingualArcBottom_6.stl": 14147,
	"./lingualArc/lingualArcBottom_7.stl": 274702,
	"./lingualArc/lingualArcBottom_8.stl": 145600,
	"./lingualArc/lingualArcBottom_9.stl": 297527,
	"./lingualArc/lingualArcTop_1.stl": 656314,
	"./lingualArc/lingualArcTop_10.stl": 955181,
	"./lingualArc/lingualArcTop_2.stl": 34127,
	"./lingualArc/lingualArcTop_3.stl": 666402,
	"./lingualArc/lingualArcTop_4.stl": 635773,
	"./lingualArc/lingualArcTop_5.stl": 925776,
	"./lingualArc/lingualArcTop_6.stl": 920230,
	"./lingualArc/lingualArcTop_7.stl": 911441,
	"./lingualArc/lingualArcTop_8.stl": 878815,
	"./lingualArc/lingualArcTop_9.stl": 539939,
	"./lingualBraces/lingualBracesBottom_1.stl": 126222,
	"./lingualBraces/lingualBracesBottom_10.stl": 924124,
	"./lingualBraces/lingualBracesBottom_2.stl": 436117,
	"./lingualBraces/lingualBracesBottom_3.stl": 292826,
	"./lingualBraces/lingualBracesBottom_4.stl": 224523,
	"./lingualBraces/lingualBracesBottom_5.stl": 466333,
	"./lingualBraces/lingualBracesBottom_6.stl": 593079,
	"./lingualBraces/lingualBracesBottom_7.stl": 635102,
	"./lingualBraces/lingualBracesBottom_8.stl": 499427,
	"./lingualBraces/lingualBracesBottom_9.stl": 881159,
	"./lingualBraces/lingualBracesTop_1.stl": 340463,
	"./lingualBraces/lingualBracesTop_10.stl": 774530,
	"./lingualBraces/lingualBracesTop_2.stl": 852392,
	"./lingualBraces/lingualBracesTop_3.stl": 202782,
	"./lingualBraces/lingualBracesTop_4.stl": 614213,
	"./lingualBraces/lingualBracesTop_5.stl": 710590,
	"./lingualBraces/lingualBracesTop_6.stl": 841176,
	"./lingualBraces/lingualBracesTop_7.stl": 50263,
	"./lingualBraces/lingualBracesTop_8.stl": 788880,
	"./lingualBraces/lingualBracesTop_9.stl": 897346,
	"./lingualRubber/lingualRubberBottom_1.stl": 2940,
	"./lingualRubber/lingualRubberBottom_10.stl": 809137,
	"./lingualRubber/lingualRubberBottom_2.stl": 365958,
	"./lingualRubber/lingualRubberBottom_3.stl": 508835,
	"./lingualRubber/lingualRubberBottom_4.stl": 920774,
	"./lingualRubber/lingualRubberBottom_5.stl": 392777,
	"./lingualRubber/lingualRubberBottom_6.stl": 311965,
	"./lingualRubber/lingualRubberBottom_7.stl": 509862,
	"./lingualRubber/lingualRubberBottom_8.stl": 816603,
	"./lingualRubber/lingualRubberBottom_9.stl": 140017,
	"./lingualRubber/lingualRubberTop_1.stl": 527146,
	"./lingualRubber/lingualRubberTop_10.stl": 67675,
	"./lingualRubber/lingualRubberTop_2.stl": 731078,
	"./lingualRubber/lingualRubberTop_3.stl": 933190,
	"./lingualRubber/lingualRubberTop_4.stl": 308586,
	"./lingualRubber/lingualRubberTop_5.stl": 664388,
	"./lingualRubber/lingualRubberTop_6.stl": 898228,
	"./lingualRubber/lingualRubberTop_7.stl": 728009,
	"./lingualRubber/lingualRubberTop_8.stl": 139268,
	"./lingualRubber/lingualRubberTop_9.stl": 501783,
	"./metallBraces/metallBracesBottom_1.stl": 473833,
	"./metallBraces/metallBracesBottom_10.stl": 154708,
	"./metallBraces/metallBracesBottom_2.stl": 491280,
	"./metallBraces/metallBracesBottom_3.stl": 603616,
	"./metallBraces/metallBracesBottom_4.stl": 246123,
	"./metallBraces/metallBracesBottom_5.stl": 576174,
	"./metallBraces/metallBracesBottom_6.stl": 817291,
	"./metallBraces/metallBracesBottom_7.stl": 671893,
	"./metallBraces/metallBracesBottom_8.stl": 534905,
	"./metallBraces/metallBracesBottom_9.stl": 182285,
	"./metallBraces/metallBracesTop_1.stl": 162142,
	"./metallBraces/metallBracesTop_10.stl": 244179,
	"./metallBraces/metallBracesTop_2.stl": 320414,
	"./metallBraces/metallBracesTop_3.stl": 228414,
	"./metallBraces/metallBracesTop_4.stl": 385955,
	"./metallBraces/metallBracesTop_5.stl": 956935,
	"./metallBraces/metallBracesTop_6.stl": 589156,
	"./metallBraces/metallBracesTop_7.stl": 316444,
	"./metallBraces/metallBracesTop_8.stl": 123365,
	"./metallBraces/metallBracesTop_9.stl": 81803,
	"./metallRubber/metallRubberBottom_1.stl": 752500,
	"./metallRubber/metallRubberBottom_10.stl": 700571,
	"./metallRubber/metallRubberBottom_2.stl": 651472,
	"./metallRubber/metallRubberBottom_3.stl": 358758,
	"./metallRubber/metallRubberBottom_4.stl": 233185,
	"./metallRubber/metallRubberBottom_5.stl": 272450,
	"./metallRubber/metallRubberBottom_6.stl": 284615,
	"./metallRubber/metallRubberBottom_7.stl": 588838,
	"./metallRubber/metallRubberBottom_8.stl": 557215,
	"./metallRubber/metallRubberBottom_9.stl": 464555,
	"./metallRubber/metallRubberTop_1.stl": 791,
	"./metallRubber/metallRubberTop_10.stl": 24108,
	"./metallRubber/metallRubberTop_2.stl": 996473,
	"./metallRubber/metallRubberTop_3.stl": 965825,
	"./metallRubber/metallRubberTop_4.stl": 397221,
	"./metallRubber/metallRubberTop_5.stl": 334014,
	"./metallRubber/metallRubberTop_6.stl": 590560,
	"./metallRubber/metallRubberTop_7.stl": 609021,
	"./metallRubber/metallRubberTop_8.stl": 914704,
	"./metallRubber/metallRubberTop_9.stl": 847556,
	"./selfAlignBraces/selfAlignBracesBottom_1.stl": 559569,
	"./selfAlignBraces/selfAlignBracesBottom_10.stl": 82470,
	"./selfAlignBraces/selfAlignBracesBottom_2.stl": 251909,
	"./selfAlignBraces/selfAlignBracesBottom_3.stl": 928153,
	"./selfAlignBraces/selfAlignBracesBottom_4.stl": 556999,
	"./selfAlignBraces/selfAlignBracesBottom_5.stl": 937309,
	"./selfAlignBraces/selfAlignBracesBottom_6.stl": 334171,
	"./selfAlignBraces/selfAlignBracesBottom_7.stl": 588870,
	"./selfAlignBraces/selfAlignBracesBottom_8.stl": 165253,
	"./selfAlignBraces/selfAlignBracesBottom_9.stl": 239724,
	"./selfAlignBraces/selfAlignBracesTop_1.stl": 350530,
	"./selfAlignBraces/selfAlignBracesTop_10.stl": 660363,
	"./selfAlignBraces/selfAlignBracesTop_2.stl": 298945,
	"./selfAlignBraces/selfAlignBracesTop_3.stl": 166881,
	"./selfAlignBraces/selfAlignBracesTop_4.stl": 132188,
	"./selfAlignBraces/selfAlignBracesTop_5.stl": 406357,
	"./selfAlignBraces/selfAlignBracesTop_6.stl": 622683,
	"./selfAlignBraces/selfAlignBracesTop_7.stl": 581220,
	"./selfAlignBraces/selfAlignBracesTop_8.stl": 162395,
	"./selfAlignBraces/selfAlignBracesTop_9.stl": 45185,
	"./tooth/_11_1.stl": 720628,
	"./tooth/_11_10.stl": 40760,
	"./tooth/_11_2.stl": 47345,
	"./tooth/_11_3.stl": 924480,
	"./tooth/_11_4.stl": 535519,
	"./tooth/_11_5.stl": 327725,
	"./tooth/_11_6.stl": 436957,
	"./tooth/_11_7.stl": 448893,
	"./tooth/_11_8.stl": 529681,
	"./tooth/_11_9.stl": 391286,
	"./tooth/_12_1.stl": 604448,
	"./tooth/_12_10.stl": 347663,
	"./tooth/_12_2.stl": 289060,
	"./tooth/_12_3.stl": 979133,
	"./tooth/_12_4.stl": 488935,
	"./tooth/_12_5.stl": 936438,
	"./tooth/_12_6.stl": 850135,
	"./tooth/_12_7.stl": 432010,
	"./tooth/_12_8.stl": 45804,
	"./tooth/_12_9.stl": 410186,
	"./tooth/_13_1.stl": 629752,
	"./tooth/_13_10.stl": 98882,
	"./tooth/_13_2.stl": 439229,
	"./tooth/_13_3.stl": 404141,
	"./tooth/_13_4.stl": 257466,
	"./tooth/_13_5.stl": 883549,
	"./tooth/_13_6.stl": 190917,
	"./tooth/_13_7.stl": 726058,
	"./tooth/_13_8.stl": 794484,
	"./tooth/_13_9.stl": 323522,
	"./tooth/_14_1.stl": 741418,
	"./tooth/_14_10.stl": 884115,
	"./tooth/_14_2.stl": 258673,
	"./tooth/_14_3.stl": 901675,
	"./tooth/_14_4.stl": 552355,
	"./tooth/_14_5.stl": 555904,
	"./tooth/_14_6.stl": 484870,
	"./tooth/_14_7.stl": 481399,
	"./tooth/_14_8.stl": 16727,
	"./tooth/_14_9.stl": 792590,
	"./tooth/_15_1.stl": 587086,
	"./tooth/_15_10.stl": 821443,
	"./tooth/_15_2.stl": 78479,
	"./tooth/_15_3.stl": 959661,
	"./tooth/_15_4.stl": 841601,
	"./tooth/_15_5.stl": 816039,
	"./tooth/_15_6.stl": 89679,
	"./tooth/_15_7.stl": 404133,
	"./tooth/_15_8.stl": 191826,
	"./tooth/_15_9.stl": 754897,
	"./tooth/_16_1.stl": 962125,
	"./tooth/_16_10.stl": 920466,
	"./tooth/_16_2.stl": 328597,
	"./tooth/_16_3.stl": 917838,
	"./tooth/_16_4.stl": 213024,
	"./tooth/_16_5.stl": 46735,
	"./tooth/_16_6.stl": 444927,
	"./tooth/_16_7.stl": 326666,
	"./tooth/_16_8.stl": 869513,
	"./tooth/_16_9.stl": 490181,
	"./tooth/_17_1.stl": 497974,
	"./tooth/_17_10.stl": 906177,
	"./tooth/_17_2.stl": 814908,
	"./tooth/_17_3.stl": 393557,
	"./tooth/_17_4.stl": 320915,
	"./tooth/_17_5.stl": 425210,
	"./tooth/_17_6.stl": 635311,
	"./tooth/_17_7.stl": 480804,
	"./tooth/_17_8.stl": 687228,
	"./tooth/_17_9.stl": 682330,
	"./tooth/_21_1.stl": 618931,
	"./tooth/_21_10.stl": 596371,
	"./tooth/_21_2.stl": 510995,
	"./tooth/_21_3.stl": 26263,
	"./tooth/_21_4.stl": 643613,
	"./tooth/_21_5.stl": 979044,
	"./tooth/_21_6.stl": 621993,
	"./tooth/_21_7.stl": 722612,
	"./tooth/_21_8.stl": 816490,
	"./tooth/_21_9.stl": 723609,
	"./tooth/_22_1.stl": 238734,
	"./tooth/_22_10.stl": 258409,
	"./tooth/_22_2.stl": 450563,
	"./tooth/_22_3.stl": 457277,
	"./tooth/_22_4.stl": 820548,
	"./tooth/_22_5.stl": 751939,
	"./tooth/_22_6.stl": 390620,
	"./tooth/_22_7.stl": 557853,
	"./tooth/_22_8.stl": 771082,
	"./tooth/_22_9.stl": 179834,
	"./tooth/_23_1.stl": 519892,
	"./tooth/_23_10.stl": 130835,
	"./tooth/_23_2.stl": 984406,
	"./tooth/_23_3.stl": 120531,
	"./tooth/_23_4.stl": 936709,
	"./tooth/_23_5.stl": 298084,
	"./tooth/_23_6.stl": 509219,
	"./tooth/_23_7.stl": 718113,
	"./tooth/_23_8.stl": 157580,
	"./tooth/_23_9.stl": 43058,
	"./tooth/_24_1.stl": 503654,
	"./tooth/_24_10.stl": 352568,
	"./tooth/_24_2.stl": 508314,
	"./tooth/_24_3.stl": 489023,
	"./tooth/_24_4.stl": 704824,
	"./tooth/_24_5.stl": 642636,
	"./tooth/_24_6.stl": 543276,
	"./tooth/_24_7.stl": 514889,
	"./tooth/_24_8.stl": 517333,
	"./tooth/_24_9.stl": 46966,
	"./tooth/_25_1.stl": 350985,
	"./tooth/_25_10.stl": 661684,
	"./tooth/_25_2.stl": 771629,
	"./tooth/_25_3.stl": 19292,
	"./tooth/_25_4.stl": 177144,
	"./tooth/_25_5.stl": 47363,
	"./tooth/_25_6.stl": 80424,
	"./tooth/_25_7.stl": 366582,
	"./tooth/_25_8.stl": 845778,
	"./tooth/_25_9.stl": 92091,
	"./tooth/_26_1.stl": 876601,
	"./tooth/_26_10.stl": 684920,
	"./tooth/_26_2.stl": 359865,
	"./tooth/_26_3.stl": 783835,
	"./tooth/_26_4.stl": 475806,
	"./tooth/_26_5.stl": 974263,
	"./tooth/_26_6.stl": 377232,
	"./tooth/_26_7.stl": 890028,
	"./tooth/_26_8.stl": 427764,
	"./tooth/_26_9.stl": 991419,
	"./tooth/_27_1.stl": 188963,
	"./tooth/_27_10.stl": 525761,
	"./tooth/_27_2.stl": 909126,
	"./tooth/_27_3.stl": 308432,
	"./tooth/_27_4.stl": 42883,
	"./tooth/_27_5.stl": 548638,
	"./tooth/_27_6.stl": 740164,
	"./tooth/_27_7.stl": 157205,
	"./tooth/_27_8.stl": 969954,
	"./tooth/_27_9.stl": 667291,
	"./tooth/_31_1.stl": 117372,
	"./tooth/_31_10.stl": 757210,
	"./tooth/_31_2.stl": 970010,
	"./tooth/_31_3.stl": 987747,
	"./tooth/_31_4.stl": 773038,
	"./tooth/_31_5.stl": 519437,
	"./tooth/_31_6.stl": 876619,
	"./tooth/_31_7.stl": 572359,
	"./tooth/_31_8.stl": 80824,
	"./tooth/_31_9.stl": 100361,
	"./tooth/_32_1.stl": 525092,
	"./tooth/_32_10.stl": 827473,
	"./tooth/_32_2.stl": 469326,
	"./tooth/_32_3.stl": 790491,
	"./tooth/_32_4.stl": 55505,
	"./tooth/_32_5.stl": 235171,
	"./tooth/_32_6.stl": 285378,
	"./tooth/_32_7.stl": 978848,
	"./tooth/_32_8.stl": 933170,
	"./tooth/_32_9.stl": 242704,
	"./tooth/_33_1.stl": 97926,
	"./tooth/_33_10.stl": 352570,
	"./tooth/_33_2.stl": 907489,
	"./tooth/_33_3.stl": 113185,
	"./tooth/_33_4.stl": 110955,
	"./tooth/_33_5.stl": 674253,
	"./tooth/_33_6.stl": 227398,
	"./tooth/_33_7.stl": 701425,
	"./tooth/_33_8.stl": 294641,
	"./tooth/_33_9.stl": 585031,
	"./tooth/_34_1.stl": 207613,
	"./tooth/_34_10.stl": 315025,
	"./tooth/_34_2.stl": 259088,
	"./tooth/_34_3.stl": 664037,
	"./tooth/_34_4.stl": 599502,
	"./tooth/_34_5.stl": 622140,
	"./tooth/_34_6.stl": 48820,
	"./tooth/_34_7.stl": 724494,
	"./tooth/_34_8.stl": 732060,
	"./tooth/_34_9.stl": 595691,
	"./tooth/_35_1.stl": 874566,
	"./tooth/_35_10.stl": 955821,
	"./tooth/_35_2.stl": 275333,
	"./tooth/_35_3.stl": 991548,
	"./tooth/_35_4.stl": 140240,
	"./tooth/_35_5.stl": 153620,
	"./tooth/_35_6.stl": 815202,
	"./tooth/_35_7.stl": 145002,
	"./tooth/_35_8.stl": 778023,
	"./tooth/_35_9.stl": 477941,
	"./tooth/_36_1.stl": 187309,
	"./tooth/_36_10.stl": 261282,
	"./tooth/_36_2.stl": 512900,
	"./tooth/_36_3.stl": 417961,
	"./tooth/_36_4.stl": 689046,
	"./tooth/_36_5.stl": 705648,
	"./tooth/_36_6.stl": 50594,
	"./tooth/_36_7.stl": 963233,
	"./tooth/_36_8.stl": 674111,
	"./tooth/_36_9.stl": 227913,
	"./tooth/_37_1.stl": 492327,
	"./tooth/_37_10.stl": 820667,
	"./tooth/_37_2.stl": 391849,
	"./tooth/_37_3.stl": 380457,
	"./tooth/_37_4.stl": 812420,
	"./tooth/_37_5.stl": 537814,
	"./tooth/_37_6.stl": 713002,
	"./tooth/_37_7.stl": 140314,
	"./tooth/_37_8.stl": 936420,
	"./tooth/_37_9.stl": 376167,
	"./tooth/_41_1.stl": 377784,
	"./tooth/_41_10.stl": 885379,
	"./tooth/_41_2.stl": 847490,
	"./tooth/_41_3.stl": 524927,
	"./tooth/_41_4.stl": 735329,
	"./tooth/_41_5.stl": 603091,
	"./tooth/_41_6.stl": 678933,
	"./tooth/_41_7.stl": 755743,
	"./tooth/_41_8.stl": 118552,
	"./tooth/_41_9.stl": 200090,
	"./tooth/_42_1.stl": 531790,
	"./tooth/_42_10.stl": 793199,
	"./tooth/_42_2.stl": 395926,
	"./tooth/_42_3.stl": 504265,
	"./tooth/_42_4.stl": 522983,
	"./tooth/_42_5.stl": 500962,
	"./tooth/_42_6.stl": 528057,
	"./tooth/_42_7.stl": 170386,
	"./tooth/_42_8.stl": 973951,
	"./tooth/_42_9.stl": 362249,
	"./tooth/_43_1.stl": 194603,
	"./tooth/_43_10.stl": 951539,
	"./tooth/_43_2.stl": 555196,
	"./tooth/_43_3.stl": 924598,
	"./tooth/_43_4.stl": 722536,
	"./tooth/_43_5.stl": 875654,
	"./tooth/_43_6.stl": 811804,
	"./tooth/_43_7.stl": 55666,
	"./tooth/_43_8.stl": 400627,
	"./tooth/_43_9.stl": 850102,
	"./tooth/_44_1.stl": 246588,
	"./tooth/_44_10.stl": 996072,
	"./tooth/_44_2.stl": 771143,
	"./tooth/_44_3.stl": 539338,
	"./tooth/_44_4.stl": 785156,
	"./tooth/_44_5.stl": 879482,
	"./tooth/_44_6.stl": 448704,
	"./tooth/_44_7.stl": 463907,
	"./tooth/_44_8.stl": 2570,
	"./tooth/_44_9.stl": 626954,
	"./tooth/_45_1.stl": 525932,
	"./tooth/_45_10.stl": 785500,
	"./tooth/_45_2.stl": 39718,
	"./tooth/_45_3.stl": 20423,
	"./tooth/_45_4.stl": 123134,
	"./tooth/_45_5.stl": 223027,
	"./tooth/_45_6.stl": 138355,
	"./tooth/_45_7.stl": 206356,
	"./tooth/_45_8.stl": 528111,
	"./tooth/_45_9.stl": 524846,
	"./tooth/_46_1.stl": 103430,
	"./tooth/_46_10.stl": 952121,
	"./tooth/_46_2.stl": 188201,
	"./tooth/_46_3.stl": 336157,
	"./tooth/_46_4.stl": 961355,
	"./tooth/_46_5.stl": 41384,
	"./tooth/_46_6.stl": 241436,
	"./tooth/_46_7.stl": 573718,
	"./tooth/_46_8.stl": 283501,
	"./tooth/_46_9.stl": 781434,
	"./tooth/_47_1.stl": 442960,
	"./tooth/_47_10.stl": 478408,
	"./tooth/_47_2.stl": 765316,
	"./tooth/_47_3.stl": 996911,
	"./tooth/_47_4.stl": 727235,
	"./tooth/_47_5.stl": 674238,
	"./tooth/_47_6.stl": 865879,
	"./tooth/_47_7.stl": 341226,
	"./tooth/_47_8.stl": 689340,
	"./tooth/_47_9.stl": 126537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129306;